module.exports = __webpack_public_path__ + "img/avatar-one.c0f6efc4.png";